import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { useT } from "@/i18n";
import Logo from "@/components/common/Logo";
import ThemeToggle from "@/components/common/ThemeToggle";
import LanguageToggle from "@/components/common/LanguageToggle";

export default function LegalPage({ docKey }) {
  const t = useT();
  const [legal, setLegal] = useState(null);
  useEffect(() => { api.get("/public/legal").then(({ data }) => setLegal(data || {})).catch(() => setLegal({})); }, []);

  const title = t(`legal.${docKey}Title`);
  const content = (legal || {})[docKey] || "";

  return (
    <div className="min-h-screen bg-background">
      <header className="glass sticky top-0 z-50 border-b border-border/60">
        <nav className="mx-auto flex h-16 max-w-4xl items-center justify-between px-6">
          <Logo />
          <div className="flex items-center gap-2">
            <LanguageToggle />
            <ThemeToggle />
          </div>
        </nav>
      </header>
      <main className="mx-auto max-w-4xl px-6 py-16">
        <Link to="/" data-testid="legal-back" className="mb-8 inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground">
          <ArrowLeft className="h-4 w-4" />{t("legal.backHome")}
        </Link>
        <h1 className="font-display text-4xl font-black tracking-tighter sm:text-5xl" data-testid="legal-title">{title}</h1>
        {legal === null ? (
          <div className="mt-10 h-8 w-8 animate-spin rounded-full border-2 border-border border-t-brand" />
        ) : content.trim() ? (
          <div className="mt-8 whitespace-pre-wrap text-base leading-relaxed text-muted-foreground" data-testid="legal-content">{content}</div>
        ) : (
          <p className="mt-8 text-muted-foreground" data-testid="legal-empty">{t("legal.empty")}</p>
        )}
      </main>
      <footer className="border-t border-border">
        <div className="mx-auto max-w-4xl px-6 py-8 text-xs text-muted-foreground">© {new Date().getFullYear()} GeolyShop</div>
      </footer>
    </div>
  );
}
